/**
 * 顶部路由跳转进度条
 * Bai.Zhiming
 * 2019-6-26
 */
angular.module("nProgressModule", []).run(["$rootScope", "$q", function($rootScope, $q) {
    loadProgress().then(nprogress => {
        nprogress.inc(1)
        nprogress.configure({
            easing: 'ease',
            speed: 2000,
            showSpinner: false
        })
        $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {
            nprogress.start() //顶部路由进度条
        });
        $rootScope.$on("$stateChangeSuccess", function(event, unfoundState, fromState, fromParam) {
            nprogress.done()
        });
        setTimeout(() => {
            nprogress.done() //5秒钟后强制消失，解决初次路由不监控的问题
        }, 5000);
    });

    function loadProgress() {
        let deffer = $q.defer()
        $q.all([loadProgressJs(), loadProgressCss()]).then((resp) => {
            deffer.resolve(resp[0]);
        });
        return deffer.promise;
    }

    function loadProgressJs() {
        let deffer = $q.defer();
        require(['progress'], function(nprogress) {
            deffer.resolve(nprogress);
        });
        return deffer.promise;
    }

    function loadProgressCss() {
        let deffer = $q.defer();
        LazyLoad.css(["./lib/nprogress/nprogress.css"], function(nprogress) {
            deffer.resolve();
        });
        return deffer.promise;
    }
}]);